module.exports = __webpack_public_path__ + "img/coin.35d50c33.svg";